import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { MaskedLineInView, Reveal } from "@/components/Reveal";

export default function FinalCTA() {
  return (
    <section
      data-testid="final-cta"
      className="relative py-28 md:py-40 border-t border-slate-100 bg-white overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-xs uppercase tracking-[0.24em] text-blue-600 font-semibold">
          / Start
        </div>
        <h2 className="mt-6 font-display font-light tracking-tight text-slate-900 text-[11vw] md:text-[8vw] leading-[0.95]">
          <div className="block"><MaskedLineInView>Need a custom</MaskedLineInView></div>
          <div className="block">
            <MaskedLineInView delay={0.12}>
              <span className="font-serif-editorial italic">database?</span>
            </MaskedLineInView>
          </div>
        </h2>

        <Reveal delay={0.1} className="mt-10 flex flex-wrap items-center gap-4">
          <Link
            to="/contact"
            data-testid="cta-final-quote"
            className="group inline-flex items-center gap-2 rounded-full bg-slate-900 text-white pl-7 pr-6 py-5 text-base font-medium transition-all duration-300 hover:bg-blue-600 hover:shadow-xl hover:shadow-blue-500/20 active:scale-95"
          >
            Get Quote
            <ArrowUpRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={1.75} />
          </Link>
          <Link
            to="/contact"
            data-testid="cta-final-contact"
            className="group inline-flex items-center gap-2 rounded-full bg-white text-slate-900 border border-slate-300 pl-7 pr-6 py-5 text-base font-medium transition-all duration-300 hover:border-slate-900 hover:bg-slate-50 active:scale-95"
          >
            Contact Us
            <ArrowUpRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={1.75} />
          </Link>
        </Reveal>

        <Reveal delay={0.2} className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 text-sm text-slate-500">
          <div className="border-t border-slate-200 pt-6">
            <div className="uppercase tracking-[0.2em] text-slate-400 text-xs mb-2">Response</div>
            <div className="text-slate-900 font-medium">Under 30 minutes on WhatsApp</div>
          </div>
          <div className="border-t border-slate-200 pt-6">
            <div className="uppercase tracking-[0.2em] text-slate-400 text-xs mb-2">Sample</div>
            <div className="text-slate-900 font-medium">Paid sample slice, adjusted on order</div>
          </div>
          <div className="border-t border-slate-200 pt-6">
            <div className="uppercase tracking-[0.2em] text-slate-400 text-xs mb-2">Delivery</div>
            <div className="text-slate-900 font-medium">Median 24 hours in Excel/CSV</div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
